import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  dialogPaper: {
    minWidth: '400px',
    maxWidth: '480px',
    borderRadius: '8px',
  },
  dialogTitle: {
    display: 'flex',
    flexDirection: 'column',
    '& h2': {
      display: 'flex',
      flexDirection: 'column',
    },
  },
  deviceNameSubtitle: {
    fontSize: '13px',
    color: '#545964',
    fontWeight: 400,
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    paddingTop: '8px',
  },
  field: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '4px',
    },
  },
  dialogActions: {
    padding: '16px 24px',
  },
  apiError: {
    color: '#F05146',
    fontSize: '13px',
    padding: '4px 0',
  },
}));

export default useStyles;
